import { IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import { ModuleItemBox } from '../FolderModule.styles';
import { theme } from '../../../../theme';
import DefaultIcon from '../../../../components/common/DefaultIcon';
import { defaultIcon } from '../../ServiceModulesContainer';
import TextDialog from './TextDialog';

type Props = {
  name: string;
  text: string;
  type: string;
  iconName: string;
  colorHex: string | null;
  iconUrl: string | null;
  onDelete: () => void;
  onEdit: () => void;
};

const TextCard = ({ name, text, type, iconName, iconUrl, colorHex, onEdit, onDelete }: Props) => {
  const [open, setOpen] = useState(false);

  const handleModuleClick = () => setOpen(true);

  const handleEditClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEdit();
  };

  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDelete();
  };

  return (
    <>
      <ModuleItemBox onClick={handleModuleClick}>
        <DefaultIcon
          iconName={iconName ?? defaultIcon(type)}
          colorHex={colorHex ?? theme.palette.primary.main}
          iconUrl={iconUrl}
        />
        <Typography sx={{ flexGrow: 1, marginLeft: 2 }}>{name}</Typography>
        <IconButton onClick={handleEditClick}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={handleDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </ModuleItemBox>

      <TextDialog
        open={open}
        onClose={() => setOpen(false)}
        name={name}
        text={text}
      />
    </>
  );
};

export default TextCard;
